<div class="my-accreditations-page">

    @if (successMessage) {
        <div class="accreditation-success-message">
          {{ successMessage }}
        </div>
      }

    <div class="page-header">
      <div>
        <span class="page-kicker">Servicio social</span>
        <h1>Mis Acreditaciones</h1>
        <p>
          Consulta tus actividades, acreditaciones y solicitudes de horas.
        </p>
      </div>
  
      <button
        type="button"
        class="new-accreditation-button"
        (click)="openNewAccreditationModal()"
        >
        + Nueva acreditación
        </button>
    </div>
  
    <section class="activities-section">

        <div class="section-header">
          <div>
            <span class="section-kicker">Actividades</span>
            <h2>Mis actividades</h2>
            <p>
              Actividades en las que has participado o estás registrado.
            </p>
          </div>
      
          <div class="section-count">
            <strong>{{ activities.length }}</strong>
            <span>actividades</span>
          </div>
        </div>
      
        <div class="activity-tabs">

            <button
              type="button"
              class="activity-tab"
              [class.active]="!showCompletedActivities"
              (click)="toggleActivitiesView(false)"
            >
              <span>Pendientes</span>
          
              <span class="tab-count">
                {{ pendingActivities.length }}
              </span>
            </button>
          
            <button
              type="button"
              class="activity-tab"
              [class.active]="showCompletedActivities"
              (click)="toggleActivitiesView(true)"
            >
              <span>Completadas</span>
          
              <span class="tab-count">
                {{ completedActivities.length }}
              </span>
            </button>
          
          </div>
        <div class="activities-list">
      
            @for (activity of currentActivities; track activity.activityRef) {
      
            <article class="activity-card">
      
              <div class="activity-main">
      
                <span class="activity-type">
                  {{ activity.type }}
                </span>
      
                <h3>
                  {{ activity.title }}
                </h3>

                @if (activity.interactionFolio) {
                  <app-folio-pill
                    [folio]="activity.interactionFolio"
                    [interactionType]="activity.interactionType || 'OP'"
                    [showHours]="true"
                    [hours]="activity.validatedHours || activity.valueInHours || 0"
                  ></app-folio-pill>
                }
      
                <span
                  class="activity-status"
                  [class.status-registered]="activity.status === 'registered'"
                  [class.status-attended]="activity.status === 'attended'"
                  [class.status-validated]="activity.status === 'validated'"
                  [class.status-absent]="activity.status === 'absent'"
                  [class.status-cancelled]="activity.status === 'cancelled'"
                >
                  @switch (activity.status) {
      
                    @case ('registered') {
                      Registrado
                    }
      
                    @case ('attended') {
                      Asistió
                    }
      
                    @case ('validated') {
                      Horas validadas
                    }
      
                    @case ('absent') {
                      No asistió
                    }
      
                    @case ('cancelled') {
                      Cancelada
                    }
      
                    @default {
                      {{ activity.status }}
                    }
      
                  }
                </span>
      
              </div>
      
              <div class="activity-meta">
      
                <div>
                  <span>Fecha límite</span>
                  <strong>
                    {{ activity.dueDate | date:'mediumDate' }}
                  </strong>
                </div>
      
                <div>
                  <span>Horas</span>
                  <strong>
                    {{ activity.validatedHours || activity.valueInHours || 0 }} h
                  </strong>
                </div>
      
              </div>
      
            </article>
      
          } @empty {
      
            <div class="empty-state">
              <h2>Aún no tienes actividades</h2>
              <p>
                Cuando participes o te registres a una actividad,
                aparecerá aquí.
              </p>
            </div>
      
          }
      
        </div>

        @if (activitiesTotalPages > 1) {
            <div class="pagination">
              <button
                type="button"
                class="pagination-button"
                (click)="previousActivitiesPage()"
                [disabled]="activitiesPage === 1"
              >
                ←
              </button>
  
              @for (page of activitiesPages; track page) {
                <button
                  type="button"
                  class="pagination-button"
                  [class.active]="activitiesPage === page"
                  (click)="goToActivitiesPage(page)"
                >
                  {{ page }}
                </button>
              }
  
              <button
                type="button"
                class="pagination-button"
                (click)="nextActivitiesPage()"
                [disabled]="activitiesPage === activitiesTotalPages"
              >
                →
              </button>
            </div>
          }
      
    </section>
  
    <section class="accreditations-section">

        <div class="section-header">
          <div>
            <span class="section-kicker">Solicitudes</span>
      
            <h2>Solicitudes de acreditación</h2>
      
            <p>
              Acreditaciones que has solicitado por actividades realizadas
              fuera de las actividades registradas en ABAQ.
            </p>
          </div>
      
          <div class="section-count">
            <strong>{{ accreditations.length }}</strong>
            <span>solicitudes</span>
          </div>
        </div>
      
        <div class="accreditation-tabs">

            <button
              type="button"
              class="accreditation-tab"
              [class.active]="!showHistory"
              (click)="toggleAccreditationsView(false)"
            >
              <span>Pendientes</span>
          
              <span class="tab-count">
                {{ pendingAccreditations.length }}
              </span>
            </button>
          
            <button
              type="button"
              class="accreditation-tab"
              [class.active]="showHistory"
              (click)="toggleAccreditationsView(true)"
            >
              <span>Historial</span>
          
              <span class="tab-count">
                {{ historyAccreditations.length }}
              </span>
            </button>
          
          </div>
          
          <div class="accreditations-list">
      
            @for (
                accreditation of currentAccreditations;
                track accreditation._id
              ) {
      
            <article class="accreditation-card">
      
              <div class="accreditation-main">
      
                <span class="accreditation-type">
                  @switch (accreditation.type) {
      
                    @case ('EVENT') {
                      Evento ABAQ
                    }
      
                    @case ('INDUCTION') {
                      Inducción
                    }
      
                    @case ('IDENTIFICATION') {
                      Placas de identificación
                    }
      
                    @case ('STERILIZATION') {
                      Esterilización
                    }
      
                    @case ('ADOPTION') {
                      Adopción
                    }
      
                    @case ('ADOPTION_MODULE') {
                      Módulo de adopción
                    }
      
                    @case ('TALK') {
                      Plática ABAQ
                    }
      
                    @case ('CAMPAIGN') {
                      Campaña
                    }
      
                    @case ('MEDIA') {
                      Difusión en medios
                    }
      
                    @case ('SOCIAL_MEDIA') {
                      Redes sociales
                    }
      
                    @case ('DONATION') {
                      Recaudación de fondos
                    }
      
                    @case ('ADMINISTRATIVE') {
                      Actividad administrativa
                    }
      
                    @default {
                        Actividad de Servicio Social
                      }
      
                  }
                </span>
      
                <h3>
                  {{ accreditation.date | date:'mediumDate' }}
                </h3>
      
                <span
                  class="accreditation-status"
                  [class.status-pending]="accreditation.status === 'pending'"
                  [class.status-approved]="accreditation.status === 'approved'"
                  [class.status-rejected]="accreditation.status === 'rejected'"
                >
      
                  @switch (accreditation.status) {
      
                    @case ('pending') {
                      Pendiente
                    }
      
                    @case ('approved') {
                      Aprobada
                    }
      
                    @case ('rejected') {
                      Rechazada
                    }
      
                    @default {
                      {{ accreditation.status }}
                    }
      
                  }
      
                </span>

                @if (accreditation.interactionFolio) {
                  <app-folio-pill
                    [folio]="accreditation.interactionFolio"
                    [interactionType]="accreditation.interactionType || 'AC'"
                    [showHours]="true"
                    [hours]="accreditation.hoursAccredited || 0"
                  ></app-folio-pill>
                }
      
              </div>
      
              <div class="accreditation-meta">

                @switch (accreditation.type) {
              
                  @case ('EVENT') {
                    <div>
                      <span>Horas realizadas</span>
                      <strong>
                        {{ accreditation.hoursPerformed || 0 }} h
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>
                        {{
                          accreditation.hoursPerformed
                            ? accreditation.hoursAccredited || 0
                            : 0
                        }} h
                      </strong>
                    </div>
              
                    <div class="accreditation-note">
                      @if (accreditation.eventType === 'SHELTER_CLEANING') {
                        Limpieza de refugio · 4 h acreditadas por cada hora
                      } @else {
                        Evento ABAQ · 2 h acreditadas por cada hora
                      }
                    </div>
                  }
              
                  @case ('INDUCTION') {
                    <div>
                      <span>Actividad</span>
                      <strong>Inducción</strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>10 h</strong>
                    </div>
              
                    <div class="accreditation-note">
                      Horas correspondientes a la inducción de Servicio Social.
                    </div>
                  }
              
                  @case ('IDENTIFICATION') {
                    <div>
                      <span>Placas realizadas</span>
                      <strong>
                        {{ accreditation.quantity || 0 }}
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>
                        {{ (accreditation.quantity || 0) * 5 }} h
                      </strong>
                    </div>
              
                    <div class="accreditation-note">
                      5 h por cada placa de identificación.
                    </div>
                  }
              
                  @case ('STERILIZATION') {
                    <div>
                      <span>Esterilizaciones</span>
                      <strong>
                        {{ accreditation.quantity || 0 }}
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>
                        {{ (accreditation.quantity || 0) * 10 }} h
                      </strong>
                    </div>
              
                    <div class="accreditation-note">
                      10 h por cada esterilización vinculada.
                    </div>
                  }
              
                  @case ('ADOPTION') {
                    <div>
                      <span>Adopciones</span>
                      <strong>
                        {{ accreditation.quantity || 0 }}
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>
                        {{ (accreditation.quantity || 0) * 100 }} h
                      </strong>
                    </div>
              
                    <div class="accreditation-note">
                      Las horas se acreditan después de completar el periodo
                      de prueba de 15 días.
                    </div>
                  }
              
                  @case ('ADOPTION_MODULE') {
                    <div>
                      <span>Adopciones vinculadas</span>
                      <strong>
                        {{ accreditation.quantity || 0 }}
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>
                        {{ (accreditation.quantity || 0) * 40 }} h
                      </strong>
                    </div>
              
                    <div class="accreditation-note">
                      40 h por cada adopción realizada mediante módulo.
                    </div>
                  }
              
                  @case ('TALK') {
                    <div>
                      <span>Participantes</span>
                      <strong>
                        {{ accreditation.participantsCount || 0 }}
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>
                        {{
                          (accreditation.participantsCount || 0) >= 50
                            ? 50
                            : 0
                        }} h
                      </strong>
                    </div>
              
                    <div class="accreditation-note">
                      @if ((accreditation.participantsCount || 0) >= 50) {
                        ✓ Cumple el mínimo de 50 participantes.
                      } @else {
                        Se requieren al menos 50 participantes.
                      }
                    </div>
                  }
              
                  @case ('CAMPAIGN') {
                    <div>
                      <span>Animales registrados</span>
                      <strong>
                        {{ accreditation.animalsEnrolled || 0 }}
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>
                        {{
                          (accreditation.animalsEnrolled || 0) >= 60 &&
                          accreditation.infrastructureAvailable
                            ? 100
                            : 0
                        }} h
                      </strong>
                    </div>
              
                    <div class="accreditation-note">
                      @if (
                        (accreditation.animalsEnrolled || 0) >= 60 &&
                        accreditation.infrastructureAvailable
                      ) {
                        ✓ Cumple los requisitos de la campaña.
                      } @else {
                        Se requieren al menos 60 animales e infraestructura.
                      }
                    </div>
                  }
              
                  @case ('MEDIA') {
                    <div>
                      <span>Actividad</span>
                      <strong>Difusión en medios</strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>30 h</strong>
                    </div>
              
                    <div class="accreditation-note">
                      Horas correspondientes a difusión en medios.
                    </div>
                  }
              
                  @case ('SOCIAL_MEDIA') {
                    <div>
                      <span>Reacciones</span>
                      <strong>
                        {{ accreditation.reactionsCount || 0 }}
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>
                        {{
                          5 +
                          Math.floor(
                            (accreditation.reactionsCount || 0) / 5
                          )
                        }} h
                      </strong>
                    </div>
              
                    <div class="accreditation-note">
                      5 h base + 1 h por cada 5 reacciones.
                    </div>
                  }
              
                  @case ('DONATION') {
                    <div>
                      <span>Monto recaudado</span>
                      <strong>
                        ${{ accreditation.donationAmount || 0 }}
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>
                        {{
                          Math.floor(
                            (accreditation.donationAmount || 0) / 50
                          )
                        }} h
                      </strong>
                    </div>
              
                    <div class="accreditation-note">
                      1 h por cada $50 recaudados.
                    </div>
                  }
              
                  @case ('ADMINISTRATIVE') {
                    <div>
                      <span>Horas realizadas</span>
                      <strong>
                        {{ accreditation.hoursPerformed || 0 }} h
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas por acreditar</span>
                      <strong>
                        {{ accreditation.hoursAccredited || 0 }} h
                      </strong>
                    </div>
              
                    <div class="accreditation-note">
                      Horas asignadas por ABAQ según la actividad realizada.
                    </div>
                  }
              
                  @default {
                    <div>
                      <span>Horas acreditadas</span>
                      <strong>
                        {{ accreditation.hoursAccredited || 0 }} h
                      </strong>
                    </div>
              
                    <div>
                      <span>Horas realizadas</span>
                      <strong>
                        {{ accreditation.hoursPerformed || 0 }} h
                      </strong>
                    </div>
                  }
              
                }
              
              </div>

              <div class="accreditation-actions">
                <button
                  type="button"
                  class="details-button"
                  (click)="toggleAccreditationDetails(accreditation)"
                >
                  @if (expandedAccreditationId === accreditation._id) {
                    Ocultar detalles
                  } @else {
                    Ver detalles
                  }
                </button>
              </div>
              
              @if (expandedAccreditationId === accreditation._id) {
                <div class="accreditation-details">
              
                  <div class="detail-item">
                    <span>Fecha de la actividad</span>
                    <strong>
                      {{ accreditation.date | date:'mediumDate' }}
                    </strong>
                  </div>
              
                  @if (accreditation.evidenceUrl) {
                    <div class="detail-item">
                      <span>Evidencia</span>
              
                      <a
                        [href]="accreditation.evidenceUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ver evidencia
                      </a>
                    </div>
                  }
              
                  @if (accreditation.eventType) {
                    <div class="detail-item">
                      <span>Tipo de evento</span>
                      <strong>
                        {{ accreditation.eventType }}
                      </strong>
                    </div>
                  }
              
                  @if (accreditation.quantity) {
                    <div class="detail-item">
                      <span>Cantidad</span>
                      <strong>
                        {{ accreditation.quantity }}
                      </strong>
                    </div>
                  }
              
                  @if (accreditation.participantsCount) {
                    <div class="detail-item">
                      <span>Participantes</span>
                      <strong>
                        {{ accreditation.participantsCount }}
                      </strong>
                    </div>
                  }
              
                  @if (accreditation.animalsEnrolled) {
                    <div class="detail-item">
                      <span>Animales registrados</span>
                      <strong>
                        {{ accreditation.animalsEnrolled }}
                      </strong>
                    </div>
                  }
              
                  @if (accreditation.infrastructureAvailable !== undefined) {
                    <div class="detail-item">
                      <span>Infraestructura y espacio</span>
                      <strong>
                        {{ accreditation.infrastructureAvailable ? 'Sí' : 'No' }}
                      </strong>
                    </div>
                  }
              
                  @if (accreditation.reactionsCount) {
                    <div class="detail-item">
                      <span>Reacciones</span>
                      <strong>
                        {{ accreditation.reactionsCount }}
                      </strong>
                    </div>
                  }
              
                  @if (accreditation.donationAmount) {
                    <div class="detail-item">
                      <span>Monto recaudado</span>
                      <strong>
                        ${{ accreditation.donationAmount }}
                      </strong>
                    </div>
                  }
              
                  @if (accreditation.comments) {
                    <div class="detail-item detail-comments">
                      <span>Comentarios</span>
                      <p>
                        {{ accreditation.comments }}
                      </p>
                    </div>
                  }
              
                </div>
              }
      
            </article>
      
          } @empty {
      
            <div class="empty-state">
              <h2>Aún no tienes solicitudes</h2>
      
              <p>
                Cuando solicites una acreditación aparecerá aquí.
              </p>
            </div>
      
          }
      
            </div>
      
            @if (accreditationsTotalPages > 1) {
                <div class="pagination">
                  <button
                    type="button"
                    class="pagination-button"
                    (click)="previousAccreditationsPage()"
                    [disabled]="accreditationsPage === 1"
                  >
                    ←
                  </button>
              
                  @for (page of accreditationsPages; track page) {
                    <button
                      type="button"
                      class="pagination-button"
                      [class.active]="accreditationsPage === page"
                      (click)="goToAccreditationsPage(page)"
                    >
                      {{ page }}
                    </button>
                  }
              
                  <button
                    type="button"
                    class="pagination-button"
                    (click)="nextAccreditationsPage()"
                    [disabled]="accreditationsPage === accreditationsTotalPages"
                  >
                    →
                  </button>
                </div>
              }
      </section>
</div>

@if (showNewAccreditationModal) {
    <div class="accreditation-modal-overlay">
  
      <div class="accreditation-modal">
  
        <div class="accreditation-modal-header">
          <div>
            <span class="section-kicker">Nueva solicitud</span>
            <h2>Nueva acreditación</h2>
          </div>
  
          <button
            type="button"
            class="modal-close-button"
            (click)="closeNewAccreditationModal()"
          >
            ×
          </button>
        </div>
  
        <div class="accreditation-modal-body">

            <div class="form-group">
              <label for="accreditationType">
                Tipo de acreditación
              </label>
          
              <select
                id="accreditationType"
                [(ngModel)]="accreditationType"
                (ngModelChange)="selectAccreditationType()"
              >
                <option value="" disabled>
                  Selecciona una opción
                </option>
          
                <option value="EVENT">
                  Evento ABAQ
                </option>
          
                <option value="INDUCTION">
                  Inducción
                </option>
          
                <option value="IDENTIFICATION">
                  Placas de identificación
                </option>
          
                <option value="STERILIZATION">
                  Esterilización
                </option>
          
                <option value="ADOPTION">
                  Adopción
                </option>
          
                <option value="ADOPTION_MODULE">
                  Módulo de adopción
                </option>
          
                <option value="TALK">
                  Plática ABAQ
                </option>
          
                <option value="CAMPAIGN">
                  Campaña
                </option>
          
                <option value="MEDIA">
                  Difusión en medios
                </option>
          
                <option value="SOCIAL_MEDIA">
                  Redes sociales
                </option>
          
                <option value="DONATION">
                  Recaudación de fondos
                </option>
          
                <option value="ADMINISTRATIVE">
                  Actividad administrativa
                </option>
              </select>
            </div>
          
            <div class="form-group">
              <label for="accreditationDate">
                Fecha de la actividad
              </label>
          
              <input
                id="accreditationDate"
                type="date"
                [(ngModel)]="accreditationDate"
              />
            </div>
          
            @if (accreditationType === 'EVENT') {

                <div class="form-group">
                  <label for="eventType">
                    Tipo de evento
                  </label>
              
                  <select
                    id="eventType"
                    [(ngModel)]="eventType"
                  >
                    <option value="" disabled>
                      Selecciona una opción
                    </option>
              
                    <option value="GENERAL">
                      Evento ABAQ
                    </option>
              
                    <option value="SHELTER_CLEANING">
                      Limpieza de refugio
                    </option>
                  </select>
                </div>
              
                <div class="form-group">
                  <label for="hoursPerformed">
                    Horas realizadas
                  </label>
              
                  <input
                    id="hoursPerformed"
                    type="number"
                    min="0"
                    [(ngModel)]="hoursPerformed"
                    placeholder="Ej. 3"
                  />
                </div>
              
              }
              
              @if (
                accreditationType === 'IDENTIFICATION' ||
                accreditationType === 'STERILIZATION' ||
                accreditationType === 'ADOPTION' ||
                accreditationType === 'ADOPTION_MODULE'
              ) {
              
                <div class="form-group">
                  <label for="quantity">
                    Cantidad
                  </label>
              
                  <input
                    id="quantity"
                    type="number"
                    min="1"
                    [(ngModel)]="quantity"
                    placeholder="Ej. 1"
                  />
                </div>
              
              }
              
              @if (accreditationType === 'TALK') {
              
                <div class="form-group">
                  <label for="participantsCount">
                    Número de participantes
                  </label>
              
                  <input
                    id="participantsCount"
                    type="number"
                    min="0"
                    [(ngModel)]="participantsCount"
                    placeholder="Ej. 50"
                  />
                </div>
              
              }
              
              @if (accreditationType === 'CAMPAIGN') {
              
                <div class="form-group">
                  <label for="animalsEnrolled">
                    Número de animales
                  </label>
              
                  <input
                    id="animalsEnrolled"
                    type="number"
                    min="0"
                    [(ngModel)]="animalsEnrolled"
                    placeholder="Ej. 60"
                    />
                </div>
              
                <div class="form-group">
                  <label>
                    ¿Se contó con infraestructura y espacio?
                  </label>
              
                  <select [(ngModel)]="infrastructureAvailable">
                    <option value="" disabled>
                      Selecciona una opción
                    </option>
              
                    <option [ngValue]="true">
                      Sí
                    </option>
              
                    <option [ngValue]="false">
                      No
                    </option>
                  </select>
                </div>
              
              }
              
              @if (accreditationType === 'SOCIAL_MEDIA') {
              
                <div class="form-group">
                  <label for="reactionsCount">
                    Número de reacciones
                  </label>
              
                  <input
                    id="reactionsCount"
                    type="number"
                    min="0"
                    [(ngModel)]="reactionsCount"
                    placeholder="Ej. 25"
                  />
                </div>
              
              }
              
              @if (accreditationType === 'DONATION') {
              
                <div class="form-group">
                  <label for="donationAmount">
                    Monto recaudado
                  </label>
              
                  <input
                    id="donationAmount"
                    type="number"
                    min="0"
                    [(ngModel)]="donationAmount"
                    placeholder="Ej. 500"
                  />
                </div>
              
              }
              
              @if (accreditationType === 'ADMINISTRATIVE') {
              
                <div class="form-group">
                  <label for="hoursPerformed">
                    Horas realizadas
                  </label>
              
                  <input
                    id="hoursPerformed"
                    type="number"
                    min="0"
                    [(ngModel)]="hoursPerformed"
                    placeholder="Ej. 3"
                  />
                </div>
              
              }

              <div class="form-group">
                <label for="evidenceUrl">
                  Evidencia de la actividad
                </label>
              
                <input
                  id="evidenceUrl"
                  type="url"
                  [(ngModel)]="evidenceUrl"
                  placeholder="https://..."
                />
              
                <small>
                  Agrega un enlace donde ABAQ pueda consultar la evidencia.
                </small>
              </div>
              
              <div class="form-group">
                <label for="comments">
                  Comentarios
                </label>
              
                <textarea
                  id="comments"
                  rows="4"
                  [(ngModel)]="comments"
                  placeholder="Describe brevemente la actividad realizada..."
                ></textarea>
              </div>
        </div>
  
        <div class="accreditation-modal-footer">
          <button
            type="button"
            class="modal-secondary-button"
            (click)="closeNewAccreditationModal()"
          >
            Cancelar
          </button>
  
          <button
            type="button"
            class="modal-primary-button"
            [disabled]="!isAccreditationFormValid()"
            (click)="createAccreditation()"
            >
            Continuar
            </button>
        </div>
  
      </div>
  
    </div>
  }